import { SecureAction } from '../../secure-actions';

/**
 * @deprecated Please move your code to the specific domain and use DAO, DTO and model separation
 */
export class MonitoringAlertConfigurationTemplatesSecureAction extends SecureAction {
  public static readonly EDIT: SecureAction = new MonitoringAlertConfigurationTemplatesSecureAction(
    'monitoring:alert_configuration_template|edit',
  );
  public static readonly DELETE: SecureAction = new MonitoringAlertConfigurationTemplatesSecureAction(
    'monitoring:alert_configuration_template|delete',
  );
  public static readonly VIEW: SecureAction = new MonitoringAlertConfigurationTemplatesSecureAction(
    'monitoring:alert_configuration_template|view',
  );

  private constructor(name: string) {
    super(name);
  }
}
